import { ITicketTypeItem } from './interfaces/ticketTypeItem.interface';

export const allTicketTypeItem: ITicketTypeItem = {
  id: -1,
  name: 'All',
  active: true,
  locked: false,
};
